import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "common/components/toastActions/toastActions.scss";

export function ToastWithActions({
    actions,
    message,
    closeToast,
    wrapInToastIconDiv,
    iconProps,
    defaultAction = () => {}
}) {
    function handleAction(action) {
        action();
        if (closeToast) {
            closeToast();
        }
    }
    
    const btn = (props, index) => (<button key={`action_btn_${index}`} type="button" className={classNames("toast-button", props.buttonClasses)} onClick={() => handleAction(props.action)}>{props.buttonText}</button>);
    
    return (
        <div className="toast-with-action-body" onClick={() => handleAction(defaultAction)}>
            {iconProps && wrapInToastIconDiv ? <div className="toast-icon"><FontAwesomeIcon {...iconProps}/></div> : <FontAwesomeIcon {...iconProps}/>}
            <div className="message">{ message }</div>
            { actions && actions.map((props, index) => btn(props, index)) }
        </div>
    );
}
